module.exports = __webpack_public_path__ + "img/logo.f84a68a7.png";